import { Annotation } from "@annotorious/react";

export interface INursery {
  id: number;
  name: string;
}

export interface ITankStats {
  tank: ITank;
  racks: number;
  fragments: number;
  fragments_count_0_25: number;
  fragments_count_25_50: number;
  fragments_count_50_75: number;
  fragments_count_75_100: number;
  unhealthy_fragments: number;
  growth: number;
  latest_observation_date: string;
}

export interface ITank {
  id: number;
  name: string;
  description?: string;
  seafoundry_uuid?: string | null;
  tank_type: "indoor" | "outdoor";
}

export interface IRack {
  id: number;
  description?: string;
  name: string;
  tank: number;
}

export interface IRackOutplantingPrediction {
  outplant_date: string;
  uncertainty_range: number;
}

export interface IRackStats {
  rack: IRack;
  fragments: number;
  unhealthy_fragments: number;
  fragments_count_0_25: number;
  fragments_count_25_50: number;
  fragments_count_50_75: number;
  fragments_count_75_100: number;
  growth: number;
  latest_observation_date: string;
}

export interface IObservation {
  id: number;
  created: string;
  note?: string;
  image: string;
  status: "created" | "processing" | "completed" | "failed";
  annotations?: Annotation[];
  rack: number;
  growth: number;
  fragments_count_0_25: number;
  fragments_count_25_50: number;
  fragments_count_50_75: number;
  fragments_count_75_100: number;
  user: string;
}

export interface IObservationStats {
  date: string;
  average_area: number;
  predicted_area?: number;
  fragments_count: number;
  aptasia: number;
  algae: number;
  paleness: number;
  mucus: number;
  bleaching: number;
  tissue_loss: number;
  dead_fragments: number;
  parasites: number;
  predation: number;
}

export interface DeviceOrientationEventiOS extends DeviceOrientationEvent {
  requestPermission?: () => Promise<"granted" | "denied">;
}

export enum FormSteps {
  Photo = 0,
  LiveCamera = 1,
  ObservationForm = 2,
}
